import { Field, TextField } from 'payload'
import { mergeObjects } from '@utils/objects'
import { DocumentFieldProps } from '@components/(payload)/fields/text/document'
import { MaskedFieldOptions } from '@components/(payload)/fields/text/masked'
import { validateDocument, validateCpf, validateCnpj, FieldWithouType, FieldDefault, addCellComponent } from '@utils/fields'

export const DocumentFieldCpfMask: MaskedFieldOptions = {
  mask: '000.000.000-00',
  lazy: false,
  overwrite: true,
};

export const DocumentFieldCnpjMask: MaskedFieldOptions = {
  mask: '##.###.###/0000-00',
  lazy: false,
  overwrite: true,
  definitions: {
    '#': /[A-Za-z0-9]/
  }
};

/**
 * Creates a PatternField (payload-better-fields-plugin) for CPF/CNPJ documents
 *
 * @param config
 * @param options
 * @returns
 */
export function documentField(config: FieldWithouType<CustomPayloadField<TextField>>, options?: DocumentFieldProps['options']): Field[] {
  const configDefault: FieldDefault<CustomPayloadField<TextField>> = {
    type: 'text',
    validate: validateDocument,
    label: 'Documento',
    admin: {
      components: {
        Field: {
          path: '@components/(payload)/fields/text/document',
          clientProps: {
            options
          }
        },
      },
      exportable: {
        format: 'document',
      }
    }
  }

  config = mergeObjects(config, configDefault);
  const field = addCellComponent<TextField>(config as TextField, 'document')[0];

  return [ field ];
}

/**
 * Creates a PatternField (payload-better-fields-plugin) for CPF
 *
 * @param config
 * @param options
 * @returns
 */
export function cpfField(config: FieldWithouType<CustomPayloadField<TextField>>, options?: DocumentFieldProps['options']): Field[] {
  const configDefault: FieldDefault<CustomPayloadField<TextField>> = {
    type: 'text',
    validate: validateCpf,
    label: 'CPF',
    admin: {
      components: {
        Field: {
          path: '@components/(payload)/fields/text/document',
          clientProps: {
            options,
            acceptCnpj: false
          }
        },
      },
      exportable: {
        format: 'cpf',
      }
    }
  }

  config = mergeObjects(config, configDefault);
  const field = addCellComponent<TextField>(config as TextField, 'cpf')[0];

  return [ field ];
}

/**
 * Creates a PatternField (payload-better-fields-plugin) for CNPJ documents
 *
 * @param config
 * @param options
 * @returns
 */
export function cnpjField(config: FieldWithouType<CustomPayloadField<TextField>>, options?: DocumentFieldProps['options']): Field[] {
  const configDefault: FieldDefault<CustomPayloadField<TextField>> = {
    type: 'text',
    validate: validateCnpj,
    label: 'CNPJ',
    admin: {
      components: {
        Field: {
          path: '@components/(payload)/fields/text/document',
          clientProps: {
            options,
            acceptCpf: false
          }
        },
      },
      exportable: {
        format: 'cnpj',
      }
    }
  }

  config = mergeObjects(config, configDefault);
  const field = addCellComponent<TextField>(config as TextField, 'cnpj')[0];

  return [ field ];
}
